export default (education:string|undefined):string =>{
    if("факультет"===education?.toLocaleLowerCase()){
        return "Название факультета"
    }
    if("институт"===education?.toLocaleLowerCase()){
        return "Название института"
    }
    if("высшая школа"===education?.toLocaleLowerCase()){
        return "Название высшей школы"
    }
    if("вертикаль"===education?.toLocaleLowerCase()){
        return "Название вертикали"
    }

    return ""
}